export function redirect(url) {
  window.location.href = url;
}
export var openInNewTab = function openInNewTab(url) {
  return window.open(url, '_blank', 'noopener noreferrer');
};
export var hostname = function hostname() {
  var _globalThis$location;
  return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
};
export var origin = function origin() {
  var _globalThis$location2;
  return (_globalThis$location2 = globalThis.location) === null || _globalThis$location2 === void 0 ? void 0 : _globalThis$location2.origin;
};
export var pathname = function pathname() {
  var _globalThis$location3;
  return (_globalThis$location3 = globalThis.location) === null || _globalThis$location3 === void 0 ? void 0 : _globalThis$location3.pathname;
};